export default (router) => {
  const destinationURL = window.localStorage.getItem('destinationURL') || '/'
  window.localStorage.removeItem('destinationURL')
  router.push(destinationURL)
}
